import React from "react";
import ContentButton from "../core/ui/ContentButton";

interface CtaSectionProps {
  heading: React.ReactNode;
  body: React.ReactNode;
  primaryLabel?: string;
  primaryHref?: string;
  secondaryLabel?: string;
  secondaryHref?: string;
}

const CtaSection: React.FC<CtaSectionProps> = ({
  heading,
  body,
  primaryLabel = "Request a walkthrough →",
  primaryHref = "https://calendar.app.google/rQuDdWM57HswfdSB9",
  secondaryLabel = "See how it works",
  secondaryHref = "#how-it-works",
}) => {
  const primaryIsExternal = /^https?:/.test(primaryHref);
  return (
    <section className="cs-section cs-cta">
      <div className="cs-cta-inner">
        <h2>{heading}</h2>
        <p>{body}</p>
        <div className="cs-cta-actions">
          <ContentButton
            href={primaryHref}
            variant="primary"
            size="lg"
            target={primaryIsExternal ? "_blank" : undefined}
            rel={primaryIsExternal ? "noopener noreferrer" : undefined}
          >
            {primaryLabel}
          </ContentButton>
          <ContentButton href={secondaryHref} variant="secondary" size="lg">
            {secondaryLabel}
          </ContentButton>
        </div>
      </div>
    </section>
  );
};

export default CtaSection;
